import { BodyMediumRegular, Spinner, YStack } from 'smoothie';

import {
    useGetFruitSlice,
    useListFruitSliceFrames,
} from '../hooks/useFruitSlices';
import { FruitSliceHost } from './FruitSliceHost';
import { FruitSliceManagementPage } from './FruitSliceManagementPage';

export const FruitSliceViewerPage = ({
    sliceId,
    frameId,
}: {
    sliceId: string;
    frameId?: string;
}) => {
    const { data: slice, isPending } = useGetFruitSlice(sliceId);
    const { data: frames = [], isPending: areFramesPending } =
        useListFruitSliceFrames(sliceId);
    const pageFrames = frames.filter((frame) => frame.type === 'PAGE');
    const selectedPage =
        frameId != null
            ? pageFrames.find((frame) => frame.id === frameId)
            : pageFrames.length === 1
              ? pageFrames[0]
              : undefined;
    const requestedFrameMissing =
        frameId != null &&
        !areFramesPending &&
        pageFrames.every((frame) => frame.id !== frameId);

    return (
        <YStack flex={1} width="100%" height="100%" minHeight="80vh">
            {isPending || areFramesPending ? (
                <YStack
                    flex={1}
                    alignItems="center"
                    justifyContent="center"
                    padding="$6"
                >
                    <Spinner />
                </YStack>
            ) : slice != null && selectedPage != null ? (
                <FruitSliceHost
                    key={selectedPage.id}
                    slice={slice}
                    frame={selectedPage}
                />
            ) : slice != null && requestedFrameMissing ? (
                <YStack
                    flex={1}
                    alignItems="center"
                    justifyContent="center"
                    padding="$6"
                >
                    <BodyMediumRegular color="$gray800">
                        Page frame “{frameId}” not found.
                    </BodyMediumRegular>
                </YStack>
            ) : slice != null ? (
                <FruitSliceManagementPage sliceId={sliceId} />
            ) : (
                <YStack
                    flex={1}
                    alignItems="center"
                    justifyContent="center"
                    padding="$6"
                >
                    <BodyMediumRegular color="$gray800">
                        Fruit Slice “{sliceId}” not found.
                    </BodyMediumRegular>
                </YStack>
            )}
        </YStack>
    );
};
